/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './pharmacy-credit.reducer';

export const PharmacyCreditDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const pharmacyCreditEntity = useAppSelector(state => state.pharmacyCredit.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="pharmacyCreditDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.pharmacyCredit.detail.title">PharmacyCredit</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.pharmacyCredit.id">Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyCreditEntity.id}</dd>
          <dt>
            <span id="totalAmount">
              <Translate contentKey="tinyMedicRestApp.pharmacyCredit.totalAmount">Total Amount</Translate>
            </span>
          </dt>
          <dd>{pharmacyCreditEntity.totalAmount}</dd>
          <dt>
            <span id="paidAmount">
              <Translate contentKey="tinyMedicRestApp.pharmacyCredit.paidAmount">Paid Amount</Translate>
            </span>
          </dt>
          <dd>{pharmacyCreditEntity.paidAmount}</dd>
          <dt>
            <span id="pendingAmount">
              <Translate contentKey="tinyMedicRestApp.pharmacyCredit.pendingAmount">Pending Amount</Translate>
            </span>
          </dt>
          <dd>{pharmacyCreditEntity.pendingAmount}</dd>
          <dt>
            <span id="creditType">
              <Translate contentKey="tinyMedicRestApp.pharmacyCredit.creditType">Credit Type</Translate>
            </span>
          </dt>
          <dd>{pharmacyCreditEntity.creditType}</dd>
          <dt>
            <span id="addedById">
              <Translate contentKey="tinyMedicRestApp.pharmacyCredit.addedById">Added By Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyCreditEntity.addedById}</dd>
          <dt>
            <span id="modifiedById">
              <Translate contentKey="tinyMedicRestApp.pharmacyCredit.modifiedById">Modified By Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyCreditEntity.modifiedById}</dd>
          <dt>
            <span id="closureStatus">
              <Translate contentKey="tinyMedicRestApp.pharmacyCredit.closureStatus">Closure Status</Translate>
            </span>
          </dt>
          <dd>{pharmacyCreditEntity.closureStatus}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.pharmacyCredit.active">Active</Translate>
            </span>
          </dt>
          <dd>{pharmacyCreditEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.pharmacyCredit.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{pharmacyCreditEntity.cursor}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.pharmacyCredit.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{pharmacyCreditEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.pharmacyCredit.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{pharmacyCreditEntity.microSec}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.pharmacyCredit.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{pharmacyCreditEntity.lastUpdated}</dd>
          <dt>
            <span id="addedByType">
              <Translate contentKey="tinyMedicRestApp.pharmacyCredit.addedByType">Added By Type</Translate>
            </span>
          </dt>
          <dd>{pharmacyCreditEntity.addedByType}</dd>
          <dt>
            <span id="modifiedByType">
              <Translate contentKey="tinyMedicRestApp.pharmacyCredit.modifiedByType">Modified By Type</Translate>
            </span>
          </dt>
          <dd>{pharmacyCreditEntity.modifiedByType}</dd>
          <dt>
            <span id="cancelledReason">
              <Translate contentKey="tinyMedicRestApp.pharmacyCredit.cancelledReason">Cancelled Reason</Translate>
            </span>
          </dt>
          <dd>{pharmacyCreditEntity.cancelledReason}</dd>
          <dt>
            <span id="billNumber">
              <Translate contentKey="tinyMedicRestApp.pharmacyCredit.billNumber">Bill Number</Translate>
            </span>
            <UncontrolledTooltip target="billNumber">
              <Translate contentKey="tinyMedicRestApp.pharmacyCredit.help.billNumber" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacyCreditEntity.billNumber}</dd>
          <dt>
            <span id="amended">
              <Translate contentKey="tinyMedicRestApp.pharmacyCredit.amended">Amended</Translate>
            </span>
            <UncontrolledTooltip target="amended">
              <Translate contentKey="tinyMedicRestApp.pharmacyCredit.help.amended" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacyCreditEntity.amended ? 'true' : 'false'}</dd>
          <dt>
            <span id="preGst">
              <Translate contentKey="tinyMedicRestApp.pharmacyCredit.preGst">Pre Gst</Translate>
            </span>
            <UncontrolledTooltip target="preGst">
              <Translate contentKey="tinyMedicRestApp.pharmacyCredit.help.preGst" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacyCreditEntity.preGst ? 'true' : 'false'}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyCredit.pharmacy">Pharmacy</Translate>
          </dt>
          <dd>{pharmacyCreditEntity.pharmacy ? pharmacyCreditEntity.pharmacy.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyCredit.supplier">Supplier</Translate>
          </dt>
          <dd>{pharmacyCreditEntity.supplier ? pharmacyCreditEntity.supplier.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyCredit.purchasePayment">Purchase Payment</Translate>
          </dt>
          <dd>{pharmacyCreditEntity.purchasePayment ? pharmacyCreditEntity.purchasePayment.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyCredit.returnPayment">Return Payment</Translate>
          </dt>
          <dd>{pharmacyCreditEntity.returnPayment ? pharmacyCreditEntity.returnPayment.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyCredit.amendedFrom">Amended From</Translate>
          </dt>
          <dd>{pharmacyCreditEntity.amendedFrom ? pharmacyCreditEntity.amendedFrom.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyCredit.amendedTo">Amended To</Translate>
          </dt>
          <dd>{pharmacyCreditEntity.amendedTo ? pharmacyCreditEntity.amendedTo.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyCredit.invoiceType">Invoice Type</Translate>
          </dt>
          <dd>{pharmacyCreditEntity.invoiceType ? pharmacyCreditEntity.invoiceType.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyCredit.urType">Ur Type</Translate>
          </dt>
          <dd>{pharmacyCreditEntity.urType ? pharmacyCreditEntity.urType.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/pharmacy-credit" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/pharmacy-credit/${pharmacyCreditEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PharmacyCreditDetail;
